export default {
    SUBSCRIPTION_GROUP_PROD : ["ec6a6556-6ff4-4d09-910a-da045509c90b", "83bf385a-31b1-40f2-b2cb-cbe3c5b53c8a"],
    SUBSCRIPTION_GROUP_NONPROD : ["6af67633-d317-4827-be7b-a2158db4ba45", "1127e7c9-617f-4adf-be76-2c840e790ac4"],
};